// Textos de Faturamento e custos da Farm (02/11/2026), coletados por glob em core/i18n/messages.ts.
export default {
  pt: {
    'farm.financeiro.ajuda': 'As notas vêm dos arquivos de faturamento e de compras do Protheus, enviados na aba Arquivos. Cada filial leva ao imóvel pelo mesmo mapa da Equipe. O período e o imóvel valem para os indicadores, o gráfico e as listas.',
    'farm.financeiro.de': 'De',
    'farm.financeiro.ate': 'Até',
    'farm.financeiro.imovel': 'Imóvel',
    'farm.financeiro.todos': 'Todos',
    'farm.financeiro.busca': 'Buscar por nota, cliente ou produto',
    'farm.financeiro.buscaCompras': 'Buscar por nota, fornecedor ou produto',
    'farm.financeiro.excel': 'Excel',
    'farm.financeiro.kpi.receita': 'Receita',
    'farm.financeiro.kpi.custo': 'Custo',
    'farm.financeiro.kpi.resultado': 'Resultado',
    'farm.financeiro.kpi.clientes': 'Clientes',
    'farm.financeiro.kpi.notasVenda': '{{n}} notas de venda',
    'farm.financeiro.kpi.notasCompra': '{{n}} notas de compra',
    'farm.financeiro.kpi.margem': 'Margem de {{p}}',
    'farm.financeiro.kpi.clientesDica': 'Clientes com nota de venda no período',
    'farm.financeiro.grafico.titulo': 'Receita e custo por mês',
    'farm.financeiro.grafico.subtitulo': 'Valores em R$ mil',
    'farm.financeiro.grafico.receita': 'Receita',
    'farm.financeiro.grafico.custo': 'Custo',
    'farm.financeiro.grafico.vazio': 'Sem notas no período',
    'farm.financeiro.ranking.titulo': 'Maiores clientes',
    'farm.financeiro.ranking.notas': '{{n}} notas',
    'farm.financeiro.ranking.umaNota': '1 nota',
    'farm.financeiro.ranking.vazio': 'Nenhuma venda no período.',
    'farm.financeiro.ranking.filtrar': 'Ver as notas de {{nome}}',
    'farm.financeiro.aba.vendas': 'Vendas',
    'farm.financeiro.aba.compras': 'Compras',
    'farm.financeiro.aba.arquivos': 'Arquivos',
    'farm.financeiro.col.nota': 'Nota',
    'farm.financeiro.col.cliente': 'Cliente',
    'farm.financeiro.col.fornecedor': 'Fornecedor',
    'farm.financeiro.col.imovel': 'Imóvel',
    'farm.financeiro.col.produto': 'Produto',
    'farm.financeiro.col.valor': 'Valor',
    'farm.financeiro.serie': 'Série {{s}}',
    'farm.financeiro.semResultado': 'Nada para mostrar com estes filtros.',
    'farm.financeiro.totalDaLista': 'Total do filtro',
    'farm.financeiro.arquivos.grupo': 'Origens',
    'farm.financeiro.arquivos.nome.faturamento': 'Faturamento do Protheus',
    'farm.financeiro.arquivos.nome.compras': 'Compras do Protheus',
    'farm.financeiro.arquivos.subtitulo.faturamento': 'Notas de saída por filial',
    'farm.financeiro.arquivos.subtitulo.compras': 'Notas de entrada por filial',
    'farm.financeiro.arquivos.ultimo': 'Último envio {{data}}',
    'farm.financeiro.arquivos.nunca': 'Nenhum envio ainda',
    'farm.financeiro.arquivos.por': 'por {{quem}}',
    'farm.financeiro.arquivos.historico': 'Histórico',
    'farm.financeiro.arquivos.col.quando': 'Quando',
    'farm.financeiro.arquivos.col.origem': 'Origem',
    'farm.financeiro.arquivos.col.arquivo': 'Arquivo',
    'farm.financeiro.arquivos.col.quem': 'Quem enviou',
    'farm.financeiro.arquivos.col.resultado': 'Resultado',
    'farm.financeiro.arquivos.col.quantidades': 'Notas',
    'farm.financeiro.arquivos.resultado.importado': 'Importado',
    'farm.financeiro.arquivos.resultado.com_pendencias': 'Com pendências',
    'farm.financeiro.arquivos.qtdNovas': '{{n}} novas',
    'farm.financeiro.arquivos.qtdAtualizadas': '{{n}} atualizadas',
    'farm.financeiro.arquivos.qtdPendentes': '{{n}} sem imóvel',
    'farm.financeiro.arquivos.semEnvios': 'Nenhum arquivo enviado.',
    'farm.financeiro.arquivos.semPermissao': 'Só quem importa o financeiro envia arquivo.',
    'farm.financeiro.envio.titulo': 'Enviar {{origem}}',
    'farm.financeiro.envio.texto': 'O arquivo do mês como sai do Protheus, em XLSX ou CSV. As notas que já existem são atualizadas, e as de filial sem imóvel ficam como pendência.',
    'farm.financeiro.envio.escolher': 'Escolher arquivo',
    'farm.financeiro.envio.trocar': 'Trocar arquivo',
    'farm.financeiro.envio.nenhum': 'Nenhum arquivo escolhido',
    'farm.financeiro.envio.enviar': 'Enviar',
    'farm.financeiro.envio.feito': 'Arquivo recebido. As notas já entram no resumo.',
    'farm.financeiro.envio.formato': 'Envie um arquivo XLSX ou CSV.',
    'farm.financeiro.envio.semArquivo': 'Escolha o arquivo do Protheus.',
  },
  en: {
    'farm.financeiro.ajuda': 'Invoices come from the Protheus sales and purchases files, sent in the Files tab. Each branch maps to a property through the same map as the Team. The period and the property apply to the indicators, the chart and the lists.',
    'farm.financeiro.de': 'From',
    'farm.financeiro.ate': 'To',
    'farm.financeiro.imovel': 'Property',
    'farm.financeiro.todos': 'All',
    'farm.financeiro.busca': 'Search by invoice, customer or product',
    'farm.financeiro.buscaCompras': 'Search by invoice, supplier or product',
    'farm.financeiro.excel': 'Excel',
    'farm.financeiro.kpi.receita': 'Revenue',
    'farm.financeiro.kpi.custo': 'Cost',
    'farm.financeiro.kpi.resultado': 'Result',
    'farm.financeiro.kpi.clientes': 'Customers',
    'farm.financeiro.kpi.notasVenda': '{{n}} sales invoices',
    'farm.financeiro.kpi.notasCompra': '{{n}} purchase invoices',
    'farm.financeiro.kpi.margem': '{{p}} margin',
    'farm.financeiro.kpi.clientesDica': 'Customers with a sales invoice in the period',
    'farm.financeiro.grafico.titulo': 'Revenue and cost by month',
    'farm.financeiro.grafico.subtitulo': 'Amounts in thousands of BRL',
    'farm.financeiro.grafico.receita': 'Revenue',
    'farm.financeiro.grafico.custo': 'Cost',
    'farm.financeiro.grafico.vazio': 'No invoices in the period',
    'farm.financeiro.ranking.titulo': 'Top customers',
    'farm.financeiro.ranking.notas': '{{n}} invoices',
    'farm.financeiro.ranking.umaNota': '1 invoice',
    'farm.financeiro.ranking.vazio': 'No sales in the period.',
    'farm.financeiro.ranking.filtrar': 'Show the invoices of {{nome}}',
    'farm.financeiro.aba.vendas': 'Sales',
    'farm.financeiro.aba.compras': 'Purchases',
    'farm.financeiro.aba.arquivos': 'Files',
    'farm.financeiro.col.nota': 'Invoice',
    'farm.financeiro.col.cliente': 'Customer',
    'farm.financeiro.col.fornecedor': 'Supplier',
    'farm.financeiro.col.imovel': 'Property',
    'farm.financeiro.col.produto': 'Product',
    'farm.financeiro.col.valor': 'Amount',
    'farm.financeiro.serie': 'Series {{s}}',
    'farm.financeiro.semResultado': 'Nothing to show with these filters.',
    'farm.financeiro.totalDaLista': 'Filtered total',
    'farm.financeiro.arquivos.grupo': 'Sources',
    'farm.financeiro.arquivos.nome.faturamento': 'Protheus sales',
    'farm.financeiro.arquivos.nome.compras': 'Protheus purchases',
    'farm.financeiro.arquivos.subtitulo.faturamento': 'Outgoing invoices by branch',
    'farm.financeiro.arquivos.subtitulo.compras': 'Incoming invoices by branch',
    'farm.financeiro.arquivos.ultimo': 'Last upload {{data}}',
    'farm.financeiro.arquivos.nunca': 'No uploads yet',
    'farm.financeiro.arquivos.por': 'by {{quem}}',
    'farm.financeiro.arquivos.historico': 'History',
    'farm.financeiro.arquivos.col.quando': 'When',
    'farm.financeiro.arquivos.col.origem': 'Source',
    'farm.financeiro.arquivos.col.arquivo': 'File',
    'farm.financeiro.arquivos.col.quem': 'Sent by',
    'farm.financeiro.arquivos.col.resultado': 'Result',
    'farm.financeiro.arquivos.col.quantidades': 'Invoices',
    'farm.financeiro.arquivos.resultado.importado': 'Imported',
    'farm.financeiro.arquivos.resultado.com_pendencias': 'With issues',
    'farm.financeiro.arquivos.qtdNovas': '{{n}} new',
    'farm.financeiro.arquivos.qtdAtualizadas': '{{n}} updated',
    'farm.financeiro.arquivos.qtdPendentes': '{{n}} without property',
    'farm.financeiro.arquivos.semEnvios': 'No files sent.',
    'farm.financeiro.arquivos.semPermissao': 'Only people who import finance can send files.',
    'farm.financeiro.envio.titulo': 'Send {{origem}}',
    'farm.financeiro.envio.texto': 'The monthly file as Protheus exports it, in XLSX or CSV. Existing invoices are updated, and those from a branch without a property become issues.',
    'farm.financeiro.envio.escolher': 'Choose file',
    'farm.financeiro.envio.trocar': 'Change file',
    'farm.financeiro.envio.nenhum': 'No file chosen',
    'farm.financeiro.envio.enviar': 'Send',
    'farm.financeiro.envio.feito': 'File received. The invoices are already in the summary.',
    'farm.financeiro.envio.formato': 'Send an XLSX or CSV file.',
    'farm.financeiro.envio.semArquivo': 'Choose the Protheus file.',
  },
  es: {
    'farm.financeiro.ajuda': 'Las facturas vienen de los archivos de ventas y de compras de Protheus, enviados en la pestaña Archivos. Cada sucursal lleva al inmueble por el mismo mapa del Equipo. El período y el inmueble valen para los indicadores, el gráfico y las listas.',
    'farm.financeiro.de': 'Desde',
    'farm.financeiro.ate': 'Hasta',
    'farm.financeiro.imovel': 'Inmueble',
    'farm.financeiro.todos': 'Todos',
    'farm.financeiro.busca': 'Buscar por factura, cliente o producto',
    'farm.financeiro.buscaCompras': 'Buscar por factura, proveedor o producto',
    'farm.financeiro.excel': 'Excel',
    'farm.financeiro.kpi.receita': 'Ingresos',
    'farm.financeiro.kpi.custo': 'Costo',
    'farm.financeiro.kpi.resultado': 'Resultado',
    'farm.financeiro.kpi.clientes': 'Clientes',
    'farm.financeiro.kpi.notasVenda': '{{n}} facturas de venta',
    'farm.financeiro.kpi.notasCompra': '{{n}} facturas de compra',
    'farm.financeiro.kpi.margem': 'Margen de {{p}}',
    'farm.financeiro.kpi.clientesDica': 'Clientes con factura de venta en el período',
    'farm.financeiro.grafico.titulo': 'Ingresos y costo por mes',
    'farm.financeiro.grafico.subtitulo': 'Valores en miles de reales',
    'farm.financeiro.grafico.receita': 'Ingresos',
    'farm.financeiro.grafico.custo': 'Costo',
    'farm.financeiro.grafico.vazio': 'Sin facturas en el período',
    'farm.financeiro.ranking.titulo': 'Mayores clientes',
    'farm.financeiro.ranking.notas': '{{n}} facturas',
    'farm.financeiro.ranking.umaNota': '1 factura',
    'farm.financeiro.ranking.vazio': 'Ninguna venta en el período.',
    'farm.financeiro.ranking.filtrar': 'Ver las facturas de {{nome}}',
    'farm.financeiro.aba.vendas': 'Ventas',
    'farm.financeiro.aba.compras': 'Compras',
    'farm.financeiro.aba.arquivos': 'Archivos',
    'farm.financeiro.col.nota': 'Factura',
    'farm.financeiro.col.cliente': 'Cliente',
    'farm.financeiro.col.fornecedor': 'Proveedor',
    'farm.financeiro.col.imovel': 'Inmueble',
    'farm.financeiro.col.produto': 'Producto',
    'farm.financeiro.col.valor': 'Valor',
    'farm.financeiro.serie': 'Serie {{s}}',
    'farm.financeiro.semResultado': 'Nada para mostrar con estos filtros.',
    'farm.financeiro.totalDaLista': 'Total del filtro',
    'farm.financeiro.arquivos.grupo': 'Orígenes',
    'farm.financeiro.arquivos.nome.faturamento': 'Ventas de Protheus',
    'farm.financeiro.arquivos.nome.compras': 'Compras de Protheus',
    'farm.financeiro.arquivos.subtitulo.faturamento': 'Facturas de salida por sucursal',
    'farm.financeiro.arquivos.subtitulo.compras': 'Facturas de entrada por sucursal',
    'farm.financeiro.arquivos.ultimo': 'Último envío {{data}}',
    'farm.financeiro.arquivos.nunca': 'Ningún envío todavía',
    'farm.financeiro.arquivos.por': 'por {{quem}}',
    'farm.financeiro.arquivos.historico': 'Historial',
    'farm.financeiro.arquivos.col.quando': 'Cuándo',
    'farm.financeiro.arquivos.col.origem': 'Origen',
    'farm.financeiro.arquivos.col.arquivo': 'Archivo',
    'farm.financeiro.arquivos.col.quem': 'Quién envió',
    'farm.financeiro.arquivos.col.resultado': 'Resultado',
    'farm.financeiro.arquivos.col.quantidades': 'Facturas',
    'farm.financeiro.arquivos.resultado.importado': 'Importado',
    'farm.financeiro.arquivos.resultado.com_pendencias': 'Con pendientes',
    'farm.financeiro.arquivos.qtdNovas': '{{n}} nuevas',
    'farm.financeiro.arquivos.qtdAtualizadas': '{{n}} actualizadas',
    'farm.financeiro.arquivos.qtdPendentes': '{{n}} sin inmueble',
    'farm.financeiro.arquivos.semEnvios': 'Ningún archivo enviado.',
    'farm.financeiro.arquivos.semPermissao': 'Solo quien importa el financiero envía archivos.',
    'farm.financeiro.envio.titulo': 'Enviar {{origem}}',
    'farm.financeiro.envio.texto': 'El archivo del mes tal como sale de Protheus, en XLSX o CSV. Las facturas existentes se actualizan, y las de sucursal sin inmueble quedan como pendientes.',
    'farm.financeiro.envio.escolher': 'Elegir archivo',
    'farm.financeiro.envio.trocar': 'Cambiar archivo',
    'farm.financeiro.envio.nenhum': 'Ningún archivo elegido',
    'farm.financeiro.envio.enviar': 'Enviar',
    'farm.financeiro.envio.feito': 'Archivo recibido. Las facturas ya entran en el resumen.',
    'farm.financeiro.envio.formato': 'Envíe un archivo XLSX o CSV.',
    'farm.financeiro.envio.semArquivo': 'Elija el archivo de Protheus.',
  },
}
